import React, { useState, useEffect } from 'react';
import { 
  Button, 
  Col, 
  Form, 
  Row, 
  Table, 
  Spinner, 
  Pagination, 
  Badge,
  InputGroup,
  Modal,
  Card,
  Container
} from 'react-bootstrap';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import { ArrowLeft, FileEarmarkArrowUp, Printer, Search } from 'react-bootstrap-icons';
import Header from '../../layouts/Header';
import { useNavigate } from 'react-router-dom';

const OutletStTransaction = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const navigate = useNavigate();
    
    const accessToken = localStorage.getItem('authToken');
    const [outlets, setOutlets] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState('');
    const [selectedOutletName, setSelectedOutletName] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [rawMaterialList, setRawMaterialList] = useState([]);
    const [rmMaincategoryList, setRmMaincategoryList] = useState([]);
    const [selectedRMCategory, setSelectedRMCategory] = useState('');
    const [selectedRawMaterials, setSelectedRawMaterials] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(50);
    const [totalPages, setTotalPages] = useState(1);
    const [stockReportData, setStockReportData] = useState([]);
    const [allStockReportData, setAllStockReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [printLoading, setPrintLoading] = useState(false);
    const [outletName, setOutletName] = useState('');
    const [clicked, setClicked] = useState(false);
    const [selectedTransactionType, setSelectedTransactionType] = useState("");
    const [error, setError] = useState('');
    const [searchText, setSearchText] = useState("");
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);

    const options = rmMaincategoryList.map((rmcat) => ({
        value: rmcat?._id,
        label: rmcat?.name,
    }));   

    const rawMaterialOptions = rawMaterialList.map((rm) => ({
        value: rm?._id,
        label: rm?.name,
    }));

    const transactionTypeOptions = [
        { value: '', label: 'All Transaction Types' },
        { value: 'CENTRAL-INWARD', label: 'Central Inward' },
        { value: 'SALE', label: 'Sale' },
        { value: 'CENTRAL-TRANSFER', label: 'Central Transfer' },
        { value: 'DAMAGE', label: 'Damage' },
        { value: 'ADJUSTMENT', label: 'Adjustment' },
        { value: 'TESTING', label: 'Testing' },
        { value: 'ORDER-CANCELLATION', label: 'Order Cancellation' }
    ];

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        
        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));
        
        setStartDate(start);
        setEndDate(end);
        getOutlets();
        getRawMaterialsMainCategory();
    }, []);

    useEffect(() => {
        if (clicked && searchText === "") {
            const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
            const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
            getStockReport(currentPage, recordsPerPage, selectedOutlet, selectedRMCategory, selectedRawMaterials, selectedTransactionType, adjustedStartDate, adjustedEndDate);
        }
    }, [recordsPerPage, currentPage]);

    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("outlet", { headers });

            if (response?.data?.status === true) {
                const activeOutlets = response?.data?.data?.outlets.filter((active) => active?.status === "ACTIVE" || "INACTIVE");
                setOutlets(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getOutletName = (e) => {
        const value = outlets?.filter(val => val?._id === e);
        setOutletName(value[0]?.name || '');
    };

    const getRawMaterialsMainCategory = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("masters/rm-main-category/get", {
                headers,
            });

            if (response?.data?.status === true) {
                setRmMaincategoryList(response?.data?.data?.categories);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getRawMaterials = async (categoryId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.get(`raw-material`, { headers });

            if (response?.data?.status === true) {
                const filteredRawmaterials = response?.data?.data?.rawMaterials?.filter((fi) => fi.mainCategory._id === categoryId);
                setRawMaterialList(filteredRawmaterials);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleDownloadExcel = async () => {
        setDownloadBtnLoading(true);
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
        getStockReport(currentPage, recordsPerPage, selectedOutlet, selectedRMCategory, selectedRawMaterials, selectedTransactionType, adjustedStartDate, adjustedEndDate, true);
    }

    const getStockReport = async(page, limit, outlet, rmCategory, rawMaterial, transaction, start, end, download) => {
        setLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            let url = `stock-transactions/getOutletStockTransactions?fromDate=${start.toISOString().split("T")[0]}&toDate=${end.toISOString().split("T")[0]}&page=${page}&limit=${limit}`

            if (outlet) {
                url += `&outletId=${outlet}`;
            }

            if (rmCategory) {
                url += `&mainCategory=${rmCategory}`;
            }

            if (rawMaterial) {
                url += `&rawMaterialId=${rawMaterial}`;
            }

            if (transaction) {
                url += `&transactionType=${transaction}`;
            }

            if (download) {
                url += `&isDownload=${download}`
            }

            const response = await axios.get(url, 
                { 
                    headers, 
                    responseType: download ? 'blob' : 'json'
                }
            );

            if (download) {
                // Create a blob from the response data
                const blob = new Blob([response.data], { 
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                });
                
                // Create a link element
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                
                // Set the filename for the download
                const fileName = `Outlet Stock Transactions For ${selectedOutletName} From ${start.toISOString().split("T")[0]} to ${end.toISOString().split("T")[0]}.xlsx`;
                link.download = fileName;
                
                // Append the link to the body and trigger the download
                document.body.appendChild(link);
                link.click();
                
                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
        
                toast.success('Excel file downloaded successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light"
                });
            } else {
                setStockReportData(response?.data?.data?.outletStockTransactionRecords);
                setTotalPages(response?.data?.data?.paginationData?.NumberOfPages || 1);
            }

        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setLoading(false);
            setDownloadBtnLoading(false);
        }
    }

    const getAllStockReport = async (outlet, rmCategory, rawMaterial, transaction, start, end) => {
        setPrintLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            let url = `stock-transactions/getOutletStockTransactions?fromDate=${start.toISOString().split("T")[0]}&toDate=${end.toISOString().split("T")[0]}`

            if (outlet) {
                url += `&outletId=${outlet}`;
            }

            if (rmCategory) {
                url += `&mainCategory=${rmCategory}`;
            }

            if (rawMaterial) {
                url += `&rawMaterialId=${rawMaterial}`;
            }

            if (transaction) {
                url += `&transactionType=${transaction}`;
            }

            const response = await axios.get(url, { headers });

            setAllStockReportData(response?.data?.data?.outletStockTransactionRecords);
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setPrintLoading(false);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setClicked(true);
        setCurrentPage(1);
        
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
        
        await getStockReport(1, recordsPerPage, selectedOutlet, selectedRMCategory, selectedRawMaterials, selectedTransactionType, adjustedStartDate, adjustedEndDate);
        
        toast.success("Report generated successfully", {
            position: "top-right",
            autoClose: 2000,
            theme: "colored",
        });
    }

    const handlePrintReport = async () => {
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
        
        setPrintLoading(true);
        await getAllStockReport(selectedOutlet, selectedRMCategory, selectedRawMaterials, selectedTransactionType, adjustedStartDate, adjustedEndDate);
        setPrintLoading(false);

        const formatDate = (date) => {
            return new Date(date).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        };
        
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);

        const tableContent = `
            <table style="border-collapse: collapse; width: 100%; font-size: 12px;">
                <thead>
                    <tr style="background-color: #f8f9fa;">
                        <th style="border: 1px solid #dee2e6; padding: 8px;">#</th>
                        <th style="border: 1px solid #dee2e6; padding: 8px;">Date & Time</th>
                        <th style="border: 1px solid #dee2e6; padding: 8px;">Transaction Details</th>
                        <th style="border: 1px solid #dee2e6; padding: 8px;">Storage Location</th>
                        <th style="border: 1px solid #dee2e6; padding: 8px;">Type</th>
                        <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">Quantity</th>
                    </tr>
                </thead>
                <tbody>
                    ${allStockReportData?.length > 0 ? 
                        allStockReportData?.map((record, index) => `
                            <tr>
                                <td style="border: 1px solid #dee2e6; padding: 8px;">${index + 1}</td>
                                <td style="border: 1px solid #dee2e6; padding: 8px;">
                                    ${new Date(record?.date).toLocaleDateString('en-GB')}<br>
                                    <small>${new Date(record?.date).toLocaleTimeString('en-GB')}</small>
                                </td>
                                <td style="border: 1px solid #dee2e6; padding: 8px;">
                                    <strong>${record?.rawMaterial?.name}</strong><br>
                                    <small>${record?.rawMaterial?.mainCategory?.name} > ${record?.rawMaterial?.subCategory?.name}</small><br>
                                    <small>${record?.remark || 'No remarks'}</small>
                                </td>
                                <td style="border: 1px solid #dee2e6; padding: 8px;">
                                    ${record?.storageLocationDetails ? 
                                        `${record?.storageLocationDetails?.name}, ${record?.storageLocationDetails?.city}` : 
                                        'N/A'}
                                </td>
                                <td style="border: 1px solid #dee2e6; padding: 8px; color: ${record?.type === "CREDIT" ? "green" : "red"}">
                                    ${record?.type}<br>
                                    <small>(${record?.transactionType})</small>
                                </td>
                                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right;">
                                    ${record?.quantity?.toFixed(2)} ${record?.rawMaterial?.unit}
                                </td>
                            </tr>
                        `).join("") :
                        `<tr>
                            <td colspan="6" style="border: 1px solid #dee2e6; padding: 8px; text-align: center;">No data available</td>
                        </tr>`
                    }
                </tbody>
            </table>
        `;
    
        const win = window.open("", "_blank");
        win.document.write(`
            <html>
                <head>
                    <title>Outlet Stock Transaction Report - ${outletName}</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                        .header { display: flex; justify-content: space-between; margin-bottom: 20px; }
                        .title { font-size: 18px; font-weight: bold; }
                        .date-range { font-size: 14px; color: #666; }
                        table { width: 100%; border-collapse: collapse; }
                        th { background-color: #f8f9fa; text-align: left; }
                    </style>
                </head>
                <body>
                    <div class="header">
                        <div class="title">Outlet Stock Transaction Report - ${outletName}</div>
                        <div class="date-range">${formattedStartDate} to ${formattedEndDate}</div>
                    </div>
                    ${tableContent}
                    <script>
                        setTimeout(() => {
                            window.print();
                            window.close();
                        }, 500);
                    </script>
                </body>
            </html>
        `);
        win.document.close();
    }

    const handleEndDateChange = (date) => {

        const start = new Date(startDate);
        const end = new Date(date);

        // Remove time part
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const maxEndDate = new Date(start);
        maxEndDate.setDate(start.getDate() + 60);
        
        if (maxEndDate && startDate && maxEndDate < startDate) {
            setError('End date cannot be earlier than start date');
        } else {
            setError('');
            setEndDate(date);
        }
    };

    const renderPaginationItems = () => {
        const items = [];
        const maxVisiblePages = 5;
        let startPage, endPage;

        if (totalPages <= maxVisiblePages) {
            startPage = 1;
            endPage = totalPages;
        } else {
            const maxVisibleBeforeCurrent = Math.floor(maxVisiblePages / 2);
            const maxVisibleAfterCurrent = Math.ceil(maxVisiblePages / 2) - 1;
            
            if (currentPage <= maxVisibleBeforeCurrent) {
                startPage = 1;
                endPage = maxVisiblePages;
            } else if (currentPage + maxVisibleAfterCurrent >= totalPages) {
                startPage = totalPages - maxVisiblePages + 1;
                endPage = totalPages;
            } else {
                startPage = currentPage - maxVisibleBeforeCurrent;
                endPage = currentPage + maxVisibleAfterCurrent;
            }
        }

        if (startPage > 1) {
            items.push(
                <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
                    1
                </Pagination.Item>
            );
            if (startPage > 2) {
                items.push(<Pagination.Ellipsis key="ellipsis-start" />);
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            items.push(
                <Pagination.Item 
                    key={i} 
                    active={i === currentPage}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </Pagination.Item>
            );
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                items.push(<Pagination.Ellipsis key="ellipsis-end" />);
            }
            items.push(
                <Pagination.Item 
                    key={totalPages} 
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        return items;
    };

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
            const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
            getStockReport(page, recordsPerPage, selectedOutlet, selectedRMCategory, selectedRawMaterials, selectedTransactionType, adjustedStartDate, adjustedEndDate);
        }
    };

    const handleRMCategoryChange = (selectedOption) => {
        const categoryId = selectedOption ? selectedOption.value : '';
        setSelectedRMCategory(categoryId);
        if (categoryId) {
            getRawMaterials(categoryId);
        } else {
            setRawMaterialList([]);
        }
    };

    const handleTransactionTypeChange = (selectedOption) => {
        setSelectedTransactionType(selectedOption ? selectedOption.value : '');
    }

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                <Card className="shadow-sm border-0">
                   <Card.Header className="bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                        <div>
                            <h4 className="mb-0 fw-bold d-inline-block">
                                <i className="bi bi-shop me-2"></i>OUTLET STOCK TRANSACTIONS
                            </h4>
                        </div>
                        <div>
                            <Button 
                                variant="outline-secondary" 
                                size="sm" 
                                onClick={() => navigate('/reports/all-reports')}
                                className="me-3 d-flex align-items-center fw-semibold"
                                style={{ height: '38px' }}
                            >
                                <ArrowLeft className="me-1" /> Back to Reports
                            </Button>
                        </div>
                    </Card.Header>
                    <hr className='mt-0 mb-0' /> 
                    
                    <Card.Body>
                        {/* Filters Section */}
                        <div className="p-3 bg-light rounded-3">
                            <Form onSubmit={handleSubmit}>
                                <Row className="g-3">
                                    <Col md={4}>
                                        <Form.Group controlId="outletSelect">
                                            <Form.Label className="fw-semibold">
                                                Outlet
                                            </Form.Label>
                                            <Form.Select
                                                value={selectedOutlet}
                                                onChange={(e) => {
                                                    setSelectedOutlet(e.target.value);
                                                    setSelectedOutletName(e.target.selectedOptions[0].label)
                                                    getOutletName(e.target.value);
                                                }}
                                                className="border-secondary"
                                            >
                                                <option value="">All Outlets</option>
                                                {outlets?.map((outlet) => (
                                                    <option
                                                        key={outlet._id}
                                                        value={outlet._id}
                                                        label={`${outlet?.name}, ${outlet?.city} ${outlet?.status !== 'ACTIVE' ? ` [ ${outlet?.status} ]` : ''}`} 
                                                        style={{
                                                            color:
                                                            outlet?.status === 'ACTIVE'
                                                                ? 'black'
                                                                : outlet?.status === 'INACTIVE'
                                                                ? 'red'
                                                                : 'GrayText'
                                                        }}
                                                    >
                                                        {outlet.name} {outlet?.status !== 'ACTIVE' ? ` - ${outlet?.status}` : ''}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group controlId="transactionType">
                                            <Form.Label className="fw-semibold">
                                                Transaction Type
                                            </Form.Label>
                                            <Select
                                                isClearable
                                                options={transactionTypeOptions}
                                                value={transactionTypeOptions.find(option => option.value === selectedTransactionType)}
                                                onChange={handleTransactionTypeChange}
                                                placeholder="Select Transaction Type"
                                                className="border-secondary"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        borderColor: '#6c757d',
                                                        minHeight: '38px'
                                                    })
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>

                                    {/* <Col md={2}>
                                        <Form.Group controlId="startDate">
                                            <Form.Label className="fw-semibold">
                                                Start Date
                                            </Form.Label>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => setStartDate(date)}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Start Date"
                                                className="form-control border-secondary"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId="endDate">
                                            <Form.Label className="fw-semibold">
                                                End Date
                                            </Form.Label>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={handleEndDateChange}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="End Date"
                                                className="form-control border-secondary"
                                                minDate={startDate}
                                            />
                                            {error && <div className="text-danger small mt-1">{error}</div>}
                                        </Form.Group>
                                    </Col> */}

                                    <Col md={2}>
                                        <Form.Group controlId="startDate">
                                            <Form.Label className="fw-semibold">
                                                Start Date
                                            </Form.Label>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => {
                                                    setStartDate(date);
                                                    // Reset endDate if it exceeds the new 60-day limit
                                                    if (endDate && date && endDate > new Date(date.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                                                    setEndDate(null);
                                                    }
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Start Date"
                                                className="form-control border-secondary"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId="endDate">
                                            <Form.Label className="fw-semibold">
                                            End Date
                                            </Form.Label>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) => {
                                                    if (startDate && date > new Date(startDate.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                                                    setError("End date cannot be more than 60 days after the start date");
                                                    } else {
                                                    setError("");
                                                    handleEndDateChange(date);
                                                    }
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="End Date"
                                                className="form-control border-secondary"
                                                minDate={startDate}
                                                maxDate={startDate ? new Date(startDate.getTime() + 60 * 24 * 60 * 60 * 1000) : null}
                                            />
                                            {error && <div className="text-danger small mt-1">{error}</div>}
                                        </Form.Group>
                                    </Col>

                                </Row>

                                <Row className="g-3 mt-2">
                                    <Col md={4}>
                                        <Form.Group controlId="rmCategory">
                                            <Form.Label className="fw-semibold">
                                                Main RM Category
                                            </Form.Label>
                                            <Select
                                                isClearable
                                                value={options.find(option => option.value === selectedRMCategory)}
                                                onChange={handleRMCategoryChange}
                                                options={options}
                                                placeholder="Select Main RM Categories"
                                                className="border-secondary"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        borderColor: '#6c757d',
                                                        minHeight: '38px'
                                                    })
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group controlId="rawMaterial">
                                            <Form.Label className="fw-semibold">
                                                Raw Material
                                            </Form.Label>
                                            <Select
                                                isClearable
                                                value={rawMaterialOptions.find(option => option.value === selectedRawMaterials)}
                                                onChange={(selectedOption) => {
                                                    setSelectedRawMaterials(selectedOption ? selectedOption.value : '');
                                                }}
                                                options={rawMaterialOptions}
                                                placeholder="Select Raw Material"
                                                className="border-secondary"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        borderColor: '#6c757d',
                                                        minHeight: '38px'
                                                    })
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2} className="d-flex align-items-end">
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-100"
                                            disabled={!startDate || !endDate}
                                        >
                                            {loading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "Generate Report"
                                            )}
                                        </Button>
                                    </Col>

                                    <Col md={2} className="d-flex align-items-end">
                                        <Button
                                            variant="outline-success"
                                            className="w-100"
                                            onClick={handleDownloadExcel}
                                        >
                                            <FileEarmarkArrowUp className="me-2" />
                                            { downloadBtnLoading ? <Spinner size='sm' /> : 'Export Report'}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>

                        {/* Results Section */}
                        {!clicked ? (
                            <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
                                <div className="text-center">
                                    <i className="bi bi-clipboard-data fs-1 text-muted"></i>
                                    <h5 className="text-muted mt-3">
                                        Please select filters to view stock transactions
                                    </h5>
                                </div>
                            </div>
                        ) : (
                            <>
                                {/* Pagination and Records Per Page - Top */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="d-flex align-items-center">
                                        <span className="me-2 text-muted">Show</span>
                                        <Form.Select
                                            style={{ width: 'auto' }}
                                            value={recordsPerPage}
                                            onChange={(e) => {
                                                const selectedRecordsPerPage = Number(e.target.value);
                                                setRecordsPerPage(selectedRecordsPerPage);
                                                setCurrentPage(1);
                                                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                                                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                                                getStockReport(1, selectedRecordsPerPage, selectedOutlet, selectedRMCategory, selectedRawMaterials, selectedTransactionType, adjustedStartDate, adjustedEndDate);
                                            }}
                                            className="border-secondary"
                                        >
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                            <option value={200}>200</option>
                                            <option value={300}>300</option>
                                            <option value={500}>500</option>
                                            <option value={1000}>1000</option>
                                            <option value={2000}>2000</option>
                                        </Form.Select>
                                        <span className="ms-2 text-muted">entries</span>
                                    </div>
                                    
                                    <Pagination className="mb-0">
                                        <Pagination.Prev
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        />
                                        {renderPaginationItems()}
                                        <Pagination.Next
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        />
                                    </Pagination>
                                </div>

                                {/* Stock Transactions Table */}
                                <div className="table-responsive border rounded-3">
                                    <Table striped bordered hover className="mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th width="50">#</th>
                                                <th width="120">Date & Time</th>
                                                <th>Transaction Details</th>
                                                <th>Storage Location</th>
                                                <th width="120">Type</th>
                                                <th width="100" className="text-end">Quantity</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                        <Spinner animation="border" variant="primary" />
                                                        <p className="mt-2 mb-0">Loading transactions...</p>
                                                    </td>
                                                </tr>
                                            ) : stockReportData?.length > 0 ? (
                                                stockReportData.map((transaction, index) => (
                                                    <tr key={index}>
                                                        <td className="text-muted">
                                                            {(currentPage - 1) * recordsPerPage + index + 1}
                                                        </td>
                                                        <td>
                                                            <small>{new Date(transaction?.createdAt).toLocaleDateString('en-GB')}</small><br />
                                                            <small className="text-muted">
                                                                {new Date(transaction?.createdAt).toLocaleTimeString('en-GB')}
                                                            </small>
                                                        </td>
                                                        <td>
                                                            <div className="fw-semibold">{transaction?.rawMaterial?.name}</div>
                                                            <small className="text-primary">
                                                                {transaction?.rawMaterial?.mainCategory?.name} &gt; {transaction?.rawMaterial?.subCategory?.name}
                                                            </small><br />
                                                            <small className="text-muted">{transaction?.remark || 'No remarks'}</small>
                                                        </td>
                                                        <td>
                                                            {transaction?.storageLocationDetails ? (
                                                                <>
                                                                    {transaction?.storageLocationDetails?.name}<br />
                                                                    <small className="text-muted">
                                                                        {transaction?.storageLocationDetails?.city}, {transaction?.storageLocationDetails?.state}
                                                                    </small>
                                                                </>
                                                            ) : 'N/A'}
                                                        </td>
                                                        <td style={{ color: transaction?.type === "CREDIT" ? "green" : "red" }}>
                                                            {transaction?.type}<br />
                                                            <small>({transaction?.transactionType})</small>
                                                        </td>
                                                        <td className="text-end">
                                                            {transaction?.quantity?.toFixed(2)} {transaction?.rawMaterial?.unit}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                        <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
                                                        <p className="mt-2 mb-0 text-muted">
                                                            No transactions found for the selected criteria
                                                        </p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                                {/* Pagination and Records Per Page - Bottom */}
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <div className="text-muted">
                                        Showing {(currentPage - 1) * recordsPerPage + 1} to{' '}
                                        {Math.min(currentPage * recordsPerPage, stockReportData?.length)} of{' '}
                                        {stockReportData?.length} entries
                                    </div>
                                    <Pagination>
                                        <Pagination.Prev
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        />
                                        {renderPaginationItems()}
                                        <Pagination.Next
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        />
                                    </Pagination>
                                </div>
                            </>
                        )}
                    </Card.Body>
                </Card>
            </div>
        </React.Fragment>
    );
};

export default OutletStTransaction;